<div class="btn-group" role="group" [attr.aria-label]="ariaLabel()">
  <ng-content></ng-content>
</div>
